import { defineSlotRecipe } from '@chakra-ui/react';

export const cardSlotRecipe = defineSlotRecipe({
	base: {
		body: { p: 'md' },

		root: {
			borderRadius: 'lg',
			overflow:     'hidden',
		},
	},
	slots: [
		'root',
		'header',
		'body',
		'footer',
		'title',
		'description',
	],
});
